/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

export const statusOptions = [
  {
    label: (
      <>
        <p>Erro</p>
      </>
    ),
    value: 'ERRO',
  },
  {
    label: (
      <>
        <p>Processando</p>
      </>
    ),
    value: 'PROCESSANDO',
  },
  {
    label: (
      <>
        <p>Pendente</p>
      </>
    ),
    value: 'PENDENTE',
  },
  {
    label: (
      <>
        <p>Sucesso</p>
      </>
    ),
    value: 'SUCESSO',
  },
];
